import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/crmApi";
import { PageHeader, Loader, Empty } from "@/crm/ui";
import { Activity, PhoneCall, Mail, Users, MessageSquare, Clock, UserPlus, Sparkles, ClipboardCheck } from "lucide-react";

const ICON = { CALL: PhoneCall, EMAIL: Mail, MEETING: Users, NOTE: MessageSquare, STATUS_CHANGE: Clock, ASSIGNMENT: UserPlus, ENRICHMENT: Sparkles, QUALIFICATION: ClipboardCheck };
const TYPES = ["", "CALL", "EMAIL", "MEETING", "NOTE", "STATUS_CHANGE", "QUALIFICATION"];

export default function Activities() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [type, setType] = useState("");

  useEffect(() => {
    const params = type ? { type } : {};
    api.get("/activities", { params }).then(({ data }) => setItems(data)).catch(() => {});
  }, [type]);

  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader title="Activités" subtitle="Historique de toutes les interactions commerciales"
        actions={
          <select value={type} onChange={(e) => setType(e.target.value)} data-testid="activity-type-filter" className="px-3 py-2 rounded-lg border border-slate-300 text-sm bg-white">
            {TYPES.map((t) => <option key={t} value={t}>{t || "Tous types"}</option>)}
          </select>
        } />
      <div className="bg-white rounded-xl border border-slate-200 p-5">
        {items.length === 0 ? <Empty label="Aucune activité" icon={Activity} /> : (
          <div className="space-y-4">
            {items.map((a) => {
              const Icon = ICON[a.type] || Clock;
              return (
                <div key={a.id} className="flex gap-3 cursor-pointer hover:bg-slate-50 rounded-lg p-2 -mx-2" onClick={() => a.company_id && navigate(`/entreprises/${a.company_id}`)} data-testid="activity-row">
                  <div className="h-9 w-9 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0"><Icon size={16} /></div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-slate-800">{a.subject || a.type}</div>
                    {a.description && <div className="text-sm text-slate-500 truncate">{a.description}</div>}
                    <div className="text-xs text-slate-400 mt-0.5">{a.user_name} · {new Date(a.created_at).toLocaleString("fr-FR")}</div>
                  </div>
                  {a.result && <span className="text-xs bg-slate-100 rounded px-2 py-0.5 text-slate-600 h-fit">{a.result}</span>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
